"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./SideEffect.js"),r=require("./medium.js"),s=require("../../../use-sidecar/dist/es2015/exports.js").exportSidecar(r.effectCar,e.RemoveScrollSideCar);exports.default=s;
//# sourceMappingURL=sidecar.js.map
